import Layout    from './src/layout'
import Container from './src/container'
import Header    from './src/header'
import Main      from './src/main'
import Aside     from './src/aside'
import Footer    from './src/footer'
import Section   from './src/section'

Layout.install = function(Vue) {
  Vue.component(Layout.name, Layout)
  Vue.component(Container.name, Container)
  Vue.component(Header.name, Header)
  Vue.component(Main.name, Main)
  Vue.component(Aside.name, Aside)
  Vue.component(Footer.name, Footer)
  Vue.component(Section.name, Section)
}

export default Layout
